export const IS_DEV_ENV = process.env.NODE_ENV === 'development';
export const IS_PROD_ENV = process.env.NODE_ENV === 'production';
export const IS_TEST_ENV = process.env.NODE_ENV === 'test';
export const ENV = process.env.NODE_ENV;
export const SESSION_STORAGE_KEY = 'koddi-auth-session';
export const AUTH0_ENABLED = 'koddi-auth0-enabled';
export const THEME_STORAGE_KEY = 'koddi-current-theme';
